import { h } from 'preact';
import StepChooseGiftbox from './steps/choose-giftbox';
import StepSelectItems from './steps/select-items';
import StepComplimentaryMessage from './steps/complimentary-message';
import { t } from '../../theme/locales';
export const buildSteps = ({ giftboxProducts , diyGiftboxProducts , giftboxGroup  })=>{
    const chooseStep = {
        id: 'choose',
        title: t('gift_wrapping.steps.choose_giftbox.title'),
        render: (state, setState)=>h(StepChooseGiftbox, {
                state,
                setState,
                giftboxProducts,
                diyGiftboxProducts
            }),
        validate: (s)=>!!s.giftbox || s.giftboxGroup === 'message'
    };
    if (giftboxGroup === 'message') {
        return [
            chooseStep,
            {
                id: 'complimentary-message',
                title: t('gift_wrapping.steps.complimentary_message.title'),
                render: (state, setState)=>h(StepComplimentaryMessage, {
                        state,
                        setState
                    }),
                validate: ()=>true
            }
        ];
    }
    return [
        chooseStep,
        {
            id: 'select',
            title: t('gift_wrapping.steps.select_items.title'),
            render: (state, setState)=>h(StepSelectItems, {
                    state,
                    setState,
                    giftboxProducts
                }),
            validate: (s)=>!!s.giftbox && Array.isArray(s.items) && s.items.length > 0
        }
    ];
};
